/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Nocontent1Inputs */

const zh_learn_nocontent1 = /** @type {(inputs: Learn_Nocontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无内容`)
};

const en_learn_nocontent1 = /** @type {(inputs: Learn_Nocontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No content available`)
};

const es_learn_nocontent1 = /** @type {(inputs: Learn_Nocontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay contenido disponible`)
};

/**
* | output |
* | --- |
* | "No content available" |
*
* @param {Learn_Nocontent1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_nocontent1 = /** @type {((inputs?: Learn_Nocontent1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Nocontent1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_nocontent1(inputs)
	if (locale === "en") return en_learn_nocontent1(inputs)
	return es_learn_nocontent1(inputs)
});
export { learn_nocontent1 as "learn_noContent" }